<template>
  <DsfHomePanel
    :title="title"
    :titleIcon="titleIcon"
    :moreIcon="moreConfig.url ? 'gengduo' : ''"
    :moreConfig="moreConfig"
    :padding="padding"
    :margin="margin"
    class="dsf-management-box-notice"
    :styleType="styleType"
    :height="heightPanel"
    :borderRadius="borderRadius"
    :width="widthPanel"
    :showHead="showHead"
    v-bind="panelConfig"
  >
    <div class="dsf-home-announcemen-mail" :style="panelStyle">
      <DsfVirtualScroll>
        <DsfVirtualList
          ref="vlist"
          :isDesign="isDesign"
          :url="url"
          v-bind="{
            rowPadding,
            rowMargin,
          }"
          @list-change="listChangeFn"
          @row-click="rowClick"
        >
          <template v-if="isDesign" v-slot:list-row>
            <div
              v-for="index in 3"
              :key="index"
              class="dsf-home-list-col2-row"
              :style="{ lineHeight }"
            >
              <div
                class="dsf-home-list-col2-item ellipsis"
                title="标题"
                type="name"
              >
                如何做一个邮政合格党员
              </div>
              <div class="dsf-home-list-col2-item" type="time">2021-07-19</div>
            </div>
          </template>
          <template v-else v-slot:list-row="scope">
            <div
              class="dsf-home-list-col2-row"
              :read="scope.row.status != 0"
              :style="{ lineHeight }"
            >
              <img
                v-if="scope.row.isTop == 1"
                class="dsf-home-list-col2-item"
                type="top"
                :src="
                  require('_platform/assets/styles/themes/img/home/top.png')
                "
              />
              <div
                class="dsf-home-list-col2-item ellipsis"
                :title="scope.row.title || ''"
                type="name"
              >
                {{ scope.row.title || "" }}
              </div>
              <div class="dsf-home-list-col2-item" type="time">
                {{ scope.row.sendDateTime | time }}
              </div>
            </div>
          </template>
        </DsfVirtualList>
      </DsfVirtualScroll>
    </div>
  </DsfHomePanel>
</template>
<script>
export default dsf.component({
  name: "DsfMessageNotice",
  ctrlCaption: "通知公告",
  mixins: [$mixins.control],
  components: {},
  filters: {
    time(timeStr) {
      return dsf.date.format(timeStr, "mm-dd");
    },
  },
  props: {
    showHead: {
      default: true,
    },
    // 宽度
    width: {
      type: String,
      default: "100%",
    },
    // 高度
    height: {
      type: String,
      default: "100%",
    }, // 面板宽度
    widthPanel: {
      type: String,
      default: "100%",
    },
    // 面板高度
    heightPanel: {
      type: String,
      default: "100%",
    },
    pageSize: {
      type: Number || String,
      default: 100,
    },
    title: {
      type: String,
      default: "通知公告",
    },
    titleIcon: {
      type: String,
      default: "",
    },
    // 行高
    lineHeight: {
      type: String,
      default: "45px",
    },
    // 外边框
    margin: {
      type: Array,
      default() {
        return [10, 10, 10, 10];
      },
    },
    // 内边框
    padding: {
      type: Array,
      default() {
        return [10, 0, 20, 0];
      },
    },
    // 边框
    rowPadding: {
      type: Array,
      default() {
        return [0, 20, 0, 20];
      },
    },
    // 边框
    rowMargin: {
      type: Array,
      default() {
        return [0, 0, 0, 0];
      },
    },
    // 列表数据
    list: {
      type: Array,
      default: () => [],
    },
    dataUrl: {
      type: String,
      default: "/message/info/getMessageList?type=announcement&pageNum=1",
    },
    toConfig: {
      type: Object,
      default: () => ({}),
    },
    moreConfig: {
      type: Object,
      default: () => ({}),
    },
    styleType: {
      type: String,
      default: "one",
    },
    viewedUrl: {
      type: String,
      default: "/message/info/markRead",
    },
    // 圆角
    borderRadius: {
      type: Array,
      default() {
        return [0, 0, 0, 0];
      }
    },
    // 面板配置 star
    //  显示更多
    moreShow: {
      type: Boolean,
      default: false,
    },
    //  更多文字
    moreText: {
      type: String,
      default: "",
    },
    //  更多图标 icon名称
    moreIcon: {
      type: String,
      default: "gengduo",
    },
    //  更多图标 icon名称
    settingShow: {
      type: Boolean,
      default: false,
    },
    //  设置文字
    settingText: {
      type: String,
      default: "",
    },
    //  设置Icon
    settingIcon: {
      type: String,
      default: "shezhi",
    },
    //  显示新增
    addShow: {
      type: Boolean,
      default: false,
    },
    //  新增文字
    addText: {
      type: String,
      default: "",
    },
    //  新增Icon
    addIcon: {
      type: String,
      default: "add",
    },
    // 面板配置 end
  },
  computed: {
    controlStyle() {
      let { widthPanel, padding, height } = this;
      return { width: widthPanel, padding: padding.join("px ") + "px", height };
    },
    panelStyle() {
      let { height } = this;
      return { height };
    },
    panelConfig() {
      return {
        moreShow: this.moreShow,
        moreText: this.moreText,
        moreIcon: this.moreIcon,
        settingShow: this.settingShow,
        settingText: this.settingText,
        settingIcon: this.settingIcon,
        addShow: this.addShow,
        addText: this.addText,
        addIcon: this.addIcon
      };
    },
  },

  data() {
    return {
      url: "",
    };
  },

  watch: {},

  created() {
    if (!this.isDesign) {
      this.url = this.dataUrl + "&pageSize=" + this.pageSize;
    } else {
      this.$dispatch("design-height-change", "100%");
    }
  },

  methods: {
    reloadData() {
      this.$refs.vlist.reloadData();
    },
    listChangeFn(list) {
      this.$emit("list-change", list);
    },
    async rowClick({ args }) {
      let { toConfig } = this;
      let url = args.row.url;
      let title = args.row.title;
      await this.redRow(args.row._id);
      if (this.$listeners["row-click"]) {
        this.$dispatch("row-click", args);
      } else {
        this.$open({ ...toConfig, url, title });
      }
    },
    redRow(id) {
      return this.$http.post(this.viewedUrl, {
        id,
        type: "workrecord",
      });
    },
  },
});
</script>
